<template>
    <table class="table table-sm border">
        <tr>
            <td rowspan="2" class="p-25 border-right">
                <div class="d-flex flex-column g-25">
                    <button v-on:click="$emit('action','branch-edit',row)" class="btn btn-sm btn-icon btn-flat-danger">
                        <feather-icon icon="Edit2Icon"></feather-icon>
                    </button>
                    <button v-on:click="$emit('action','branch-delete',row)" class="btn btn-sm btn-icon btn-flat-secondary">
                        <feather-icon icon="TrashIcon"></feather-icon>
                    </button>
                </div>
            </td>
            <td class="text-nowrap border-0 w-34" :class="{'bg-light-secondary':!$safe(row,'BranchEndDateStr') && $safe(row,'Active')}">
                <small>Şube</small>
                <div class="font-weight-bolder">{{ $safe(row,'Branch.Name') || '-' }}</div>
            </td>
            <td class="text-nowrap border-0 w-33">
                <small>Giriş Tarihi</small>
                <div class="font-weight-bolder">{{ $safe(row,'BranchStartDateStr') || '-' }}</div>
            </td>
            <td class="text-nowrap border-0 w-33">
                <small>Çıkış Tarihi</small>
                <div class="font-weight-bolder">{{ $safe(row,'BranchEndDateStr') || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td colspan="3">
                <small :class="$safe(row,'BranchEndDateStr') ? 'text-muted' : 'text-secondary'">{{ text }}</small>
            </td>
        </tr>
    </table>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
    computed:{
        text(){
            if(this.row.BranchStartDateStr){
                if(this.row.BranchEndDateStr){
                    return `[${this.row.Branch?.Name || '-'}] şubesine (${this.row.BranchStartDateStr}) tarihinde girmiş, (${this.row.BranchEndDateStr}) tarinde şubeden ayrılmıştır.`
                }else return `[${this.row.Branch?.Name || '-'}] şubesine (${this.row.BranchStartDateStr}) tarihinde girmiştir ve hala bu şubede çalışmaktadır.`
            }else return null
        }
    }
}
</script>